<template>
<div id="main-container" :class='{dark: this.$store.state.dark }'>
  <SideBar></SideBar>
  <div id="main-wrapper">
    <Header></Header>
    <router-view class="content-main"></router-view>
    <footer>©{{year}} AX ACS | Android Compile Service | {{page}}</footer>
  </div>
</div>
</template>

<script>
  import Header from './../components/Header.vue'
  import SideBar from './../components/SideBar.vue'
  import prepareAppInfo from '../helpers/prepareAppInfo'

  export default {
    name: 'app',
    components: {
      SideBar,
      Header
    },
    data() {
      return {
        year: new Date().getFullYear(),
        title: this.$route.name,
      }
    },
    computed:{
      page(){
        const pageMap = {
          home: "Главная",
          apps: "Приложения",
          users: "Пользователи",
          developers: "Разработчики"
        };

        this.$store.state.page = pageMap[this.$route.name];
        return this.$store.state.page;
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">

@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url('https://fonts.googleapis.com/css?family=Montserrat:100,100i,300,300i,400,400i,500,500i,700,700i&subset=cyrillic,cyrillic-ext');
@import '../styles/variables.scss';

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

*::before {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#main-container {
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  font-family: 'Montserrat', UILanguageFont, sans-serif;
  font-weight: 300;
  text-align: center;
  max-height: 100vh;
  background-color: #fff;

  &.dark {
      background-color: $bg-black;
      color: $dark-grey;
    }
}

.content-main {
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  flex-direction: column;
  background-color: white;
  width: 100%;
  padding: 20px;
  z-index: 0;
  .dark & {
    background-color: $bg-black;
  }
}


#main-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  margin-top: 89px;
  background-color: white;
  align-items: flex-start;
  text-align: left;
}

footer {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  height: 40px;
  padding-left: 20px;
  text-align: left;
  background-color: #eee;
  font-size: 12px;

  .dark &{
    background-color: $bg-grey;
    color: $dark-grey;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
}
</style>
